import React from "react";
import styles from "./TaxDisputeReceipt.module.css";
import "../../../App.css";
import moment from "moment";

function TaxDisputeReceipt(props) {
  const showLastTwoItems = props.data?.request_status_option === "قبول الإيداع";
  
  return (
    <>
      <ul className={`${styles["custom-list"]} list-group list-group-flush`}>
        <li
          className={`${styles["flex-list"]} list-group-item d-flex justify-content-end`}
        >
          <span className={styles["text-title"]}>اسم مقدم الطلب : </span>
          <span className={styles["text-value"]}>
            {props.data.submittee_request_name
              ? props.data.submittee_request_name
              : ""}
          </span>
        </li>
        <li
          className={`${styles["flex-list"]} list-group-item d-flex justify-content-end`}
        >
          <span className={`${styles["text-title"]}`}> نوع الضريبة : </span>
          <span className={styles["text-value"]}>
            {props.data.tax_type ? props.data.tax_type : ""}
          </span>
        </li>
        <li
          className={`${styles["flex-list"]} list-group-item d-flex justify-content-end`}
        >
          <span className={styles["text-title"]}>رقم الدعوى/الطعن : </span>
          <span className={styles["text-value"]}>
            {props.data?.appeal_number ?? props.data?.lawsuit_number}
          </span>
        </li>
        <li
          className={`${styles["flex-list"]} list-group-item d-flex justify-content-end`}
        >
          <span className={styles["text-title"]}> رقم الطلب :</span>
          <span className={styles["text-value"]}>
            {props.data.request_number ? props.data.request_number : ""}
          </span>
        </li>
        <li
          className={`${styles["flex-list"]} list-group-item d-flex justify-content-end`}
        >
          <span className={styles["text-title"]}>تاريخ تقديم الطلب : </span>
          <span className={styles["text-value"]}>
            {props.data.submitted_request_date
              ? moment(props.data.submitted_request_date).format("YYYY/MM/DD") 
              : ""}
          </span>
        </li>
        <li
          className={`${styles["flex-list"]} list-group-item d-flex justify-content-end`}
        >
          <span className={styles["text-title"]}>
            الجهة المنظور أمامها النزاع :
          </span>
          <span className={styles["text-value"]}>
            {props?.data?.dispute_reviewer ? props?.data?.dispute_reviewer : ""}
          </span>
        </li>
        <li
          className={`${styles["flex-list"]} list-group-item d-flex justify-content-end`}
        >
          <span className={styles["text-title"]}> موضوع المنازعة : </span>
          <span className={styles["text-value"]}>
            {props?.data?.dispute_subject ? props?.data?.dispute_subject : ""}
          </span>
        </li>
        
        {showLastTwoItems && (
          <>
            <li
              className={`${styles["flex-list"]} list-group-item d-flex justify-content-end`}
            >
              <span className={styles["text-title"]}> اللجنة  : </span>
              <span className={styles["text-value"]}>
                {props?.data?.committee ? props?.data?.committee : ""}
              </span>
            </li>
            <li
              className={`${styles["flex-list"]} list-group-item d-flex justify-content-end`}
            >
              <span className={styles["text-title"]}> تاريخ أول جلسة  : </span>
              <span className={styles["text-value"]}>
                {props?.data?.first_session_date ?moment( props?.data?.first_session_date).format("YYYY/MM/DD") : ""} 
              </span>
            </li>
          </>
        )}
      </ul>
    </>
  );
}

export default TaxDisputeReceipt;